import { render, staticRenderFns } from "./reductionAction.vue?vue&type=template&id=06f73d48&"
import script from "./reductionAction.vue?vue&type=script&lang=js&"
export * from "./reductionAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports